import { ReactNode, useState } from "react";
import ContactModal from "../ContactModal";
import { isMobile } from "react-device-detect";
import MobileContactModal from "../MobileContactModal";

type IProps = {
  children: ReactNode;
};
const ContactContainer = (props: IProps) => {
  const { children } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const handleIsOpen = (flag: boolean) => {
    setIsOpen(flag);
  };

  return (
    <>
      <div
        className="cursor-pointer"
        onClick={() => {
          setIsOpen(true);
        }}
      >
        {children}
      </div>
      {isMobile ? (
        <MobileContactModal isOpen={isOpen} handleIsOpen={handleIsOpen} />
      ) : (
        <ContactModal isOpen={isOpen} handleIsOpen={handleIsOpen} />
      )}
    </>
  );
};

export default ContactContainer;
